import React, { useState } from "react"
import Caption from "./caption"
import Img from "gatsby-image"
import Lightbox from "react-image-lightbox"
import Spinner from './spinner'

// function windowScrollPos() {
//   if (typeof window !== "undefined") {
//     const supportPageOffset = window.pageXOffset !== undefined
//     const isCSS1Compat = (document.compatMode || "") === "CSS1Compat"

//     const x = supportPageOffset
//       ? window.pageXOffset
//       : isCSS1Compat
//         ? document.documentElement.scrollLeft
//         : document.body.scrollLeft
//     const y = supportPageOffset
//       ? window.pageYOffset
//       : isCSS1Compat
//         ? document.documentElement.scrollTop
//         : document.body.scrollTop

//     return { x, y }
//   }

//   return { x: 0, y: 0 }
// }

export default ({ caption, fluid, original, size }) => {
  const [isOpen, setOpen] = useState(false)
  // const [yPos, setYPos] = useState(windowScrollPos().y)

  return (
    <div>
      <figure className="thumbnail" id={`anchor-${caption.reference}`}>
        {fluid && <div
          className="thumbnail__image"
          onClick={() => {
            setOpen(true)
          }}
        >
          {/* <Fade distance={`1.5rem`} up> */}
          <Img fluid={fluid} backgroundColor="rgba(255, 255, 255, 0.3)" />
          {/* </Fade> */}
        </div>}
        <figcaption className="thumbnail__caption">
          <Caption {...caption} />
        </figcaption>
      </figure>

      {size !== 'large' && original && isOpen && (
        <Lightbox
          mainSrc={original.src}
          mainSrcThumbnail={fluid.base64}
          animationDisabled={true}
          imagePadding={0}
          enableZoom={true}
          reactModalProps={{ shouldFocusAfterRender: false }}
          onCloseRequest={() => {
            setOpen(false)
          }}
          spinner={Spinner}
        />
      )}
    </div>
  )
}
